"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ptBR = void 0;
var locale_1 = require("date-fns/locale");
Object.defineProperty(exports, "ptBR", { enumerable: true, get: function () { return locale_1.ptBR; } });
//# sourceMappingURL=locale.js.map